module.exports = __webpack_public_path__ + "static/Joseph Rojas-4f10805820899ff850beaa67057436ab.jpg";